import { Component, OnInit } from '@angular/core';
import { UserSessionService } from '@modules/common/services/user-session.service';
import { CurrentCaseService } from '@modules/common/services/current-case.service';
import { LogoutService } from '@modules/common/services/logout.service';
import { CurrentEnvironmentService } from '../../../common/services/current-environment.service';

@Component({
    selector: 'app-nav-user-menu',
    templateUrl: './nav-user-menu.component.html',
    styleUrls: ['./nav-user-menu.component.scss']
})
export class NavUserMenuComponent implements OnInit {
    constructor(
        private _userSessionService: UserSessionService,
        private _currentCaseService: CurrentCaseService,
        private _logoutService: LogoutService,
        private _currentEnvironmentService: CurrentEnvironmentService
    ) { }

    public userDisplayName?: string;
    public accountSettingsUrl!: string;

    public ngOnInit(): void {
        const session = this._userSessionService.getUserSession();
        this.userDisplayName = session && session.userInfo && session.userInfo.displayName;

        this.accountSettingsUrl = (this._currentEnvironmentService.getCurrentEnvironmentName() ? '/' + this._currentEnvironmentService.getCurrentEnvironmentName() : '')
            + (this._currentCaseService.getCurrentCaseName() ? '/' + this._currentCaseService.getCurrentCaseName() : '')
            + '/Users/AccountSettings';
    }

    public signOut(): void {
        this._logoutService.logout();
    }
}